import { shade } from "polished";
import styled from "styled-components";

import { size } from "~/styles/screen";

type Props = { color: string };

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 400px;
  min-width: 400px;

  @media screen and (max-width: ${size.small}) {
    padding: 0;
  }
`;

export const DarkBackground = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 30px;
  background: #1f1f1f;
  border-radius: 4px;
`;

export const Title = styled.text<Props>`
  font-family: "Roboto Slab";
  font-weight: 900;
  font-size: 22px;
  line-height: 29.01px;
  color: #72e85f;
`;

export const SubTitle = styled.text<Props>`
  font-family: "Roboto Slab";
  font-weight: 900;
  font-size: 22px;
  line-height: 29.01px;
  color: #fff;
`;

export const Button = styled.a`
  display: flex;
  cursor: pointer;
  height: 40px;
  align-items: center;
  align-self: center;
  width: 100%;
  justify-content: center;
  text-decoration: none;
  background-color: #72e85f;
  transition: background-color 0.2s;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  &:hover {
    background: ${shade(0.1, "#72E85F")};
  }
`;

export const ButtonText = styled.text`
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 14px;
  line-height: 16.8px;
  transition: color 0.2s;
  color: #1f1f1f;
`;
